import { Sport } from 'src/app/models/sports';
import { StoreAction } from '../../models/rootState.model';
// tslint:disable: class-name

export const CURRENT_SPORT_ACTIONS = {
    INIT: '[Sport] Init state',
    INIT_SUCCESS: '[Sport] Init state success',
    INIT_SUCCESS_EMPTY: '[Sport] Init state success with no definition',
    SET_ACTIVE_SPORT: '[Sport] Set active sport',
    SET_ACTIVE_SPORT_ID: '[Sport] Set active sport id',
    SET_ACTIVE_SPORT_ID_SUCCESS: '[Sport] Set active sport id success',
    SET_ACTIVE_SPORT_ID_FAIL: '[Sport] Set active sport id fail',
    RESSET: '[Sport] -User logged out-'


};

export class Action_Sport_Init implements StoreAction {
    readonly type = CURRENT_SPORT_ACTIONS.INIT;
}

export class Action_Sport_InitSuccess implements StoreAction<number> {
    readonly type = CURRENT_SPORT_ACTIONS.INIT_SUCCESS;
    constructor(public payload: number) { }
}

export class Action_Sport_InitSuccessEmpty implements StoreAction {
    readonly type = CURRENT_SPORT_ACTIONS.INIT_SUCCESS_EMPTY;
}

export class Action_Sport_SetActiveById implements StoreAction<number> {
    readonly type = CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID;
    constructor(public payload: number) { }
}

export class Action_Sport_SetActive implements StoreAction<Sport> {
    readonly type = CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT;
    constructor(public payload: Sport) { }
}

export class Action_Sport_SetActiveByIdSuccess implements StoreAction<Sport> {
    readonly type = CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID_SUCCESS;
    constructor(public payload: Sport) { }
}

export class Action_Sport_SetActiveByIdFail implements StoreAction<Error> {
    readonly type = CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID_FAIL;
    constructor(public payload: Error) { }
}

export class Action_Sport_Resset implements StoreAction {
    readonly type = CURRENT_SPORT_ACTIONS.RESSET;
}


export type CurrentSportAction =
    | Action_Sport_Init
    | Action_Sport_SetActive
    | Action_Sport_SetActiveById
    | Action_Sport_SetActiveByIdSuccess
    | Action_Sport_SetActiveByIdFail;
